import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Prefer CRA-injected REACT_APP_ env vars. If those are missing (your .env
// contains un-prefixed keys), fall back to the values from that file so
// development works without changing .env. Update .env to use REACT_APP_* in
// production.
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.apiKey || 'AIzaSyBulW_-FQCiBCgK_mqUsSBY401n4S36TR8',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.authDomain || 'interview-links-d010b.firebaseapp.com',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.projectId || 'interview-links-d010b',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.storageBucket || 'interview-links-d010b.firebasestorage.app',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.messagingSenderId || '746518324709',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.appId || '1:746518324709:web:6313b9f292037683903b0c',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.measurementId || 'G-40WSBDT2L6',
};

if (!firebaseConfig.apiKey) {
    // fail early with actionable message
    // eslint-disable-next-line no-console
    console.error('Missing Firebase API key. Set REACT_APP_FIREBASE_API_KEY in your .env or provide valid fallback keys.');
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
